/* @flow */

module.exports = {
  "LOCALE": {
    "ISO": {
      "639-1": "nb",
      "3166-1": "NO",
      "IETF": "nb-NO",
    },
    "CURRENCY": "NOK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "poeng",
    "BASIC_POINTS": "Nivåpoeng",
    "EXTRA_POINTS": "Bonuspoeng",
  },
  "META": {
    "GOOGLE_SITE_OWNER": "JE5RJH9mE7LLsEhBFrF7e0T3poF_BesW7P3wibE8XwA",
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=9d5307e802f2a6322fdfa676b3e2470c",
  },
  "SKIP_TO_CONTENT": "Hopp til innhold",
  "LOGO": {
    "ALT": "SAS",
    "TITLE": "Gå til startsiden",
  },
  "COOKIE_CONSENT": {
    "ALL": "Tillat alle",
    "SELECTED": "Tillat valg",
    "NECESSARY": "Tillat nødvendig",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nødvendig",
    "STATISTICAL": "Statistisk",
    "MARKETING": "Markedsføring",
  },
  "CURRENCY_SHORT": {
    "NOK": "kr",
    "DKK": "kr",
    "SEK": "kr",
    "EUR": "€",
  },
  "LANGUAGE_SWITCHER": {
    "CLOSE": "Lukk språkvelger",
  },
  "CLOSE_SYSTEM_MESSAGE": "Lukk melding",
  "APP": {
    "COUNTRY_MODAL": "Du har logget deg på med en EuroBonus-konto registrert i %country. Vill du skifte land?",
  },
  "HOMEVIEW": {
    "POPULAR_CATEGORIES": "Populære kategorier",
    "SEE_MORE_POPULAR_CATEGORIES": "Se flere kategorier",
    "POPULAR_PRODUCTS": "Populære produkter",
    "SEE_MORE_POPULAR_PRODUCTS": "Se mer populære produkter",
    "RECENTLY_VIEWED_PRODUCTS": "Nylig viste produkter",
  },
  "ALL_PRODUCTS": {
    "TITLE": "Alle produkter",
    "TITLE_PREFIX_LOADING": "Lader alle",
  },
  "PRODUCTLIST_HERO": {
    "PRODUCTS_FROM": "Produkter fra",
    "TITLE_PREFIX_EMPTY": "Ingen produkter å vise",
    "TITLE_PREFIX_SINGULAR": "Viser 1 produkt i <span>%title</span>",
    "TITLE_PREFIX_PLURAL": "Viser %itemsCount produkter i <span>%title</span>",
    "IN_PRICERANGE": " i prisklassen <span>%points poeng</span>",
    "POINTS": "poeng",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikkel %current av %total",
    "CONTROLS": {
      "LABEL": "Navigasjon for karusell",
      "PREV_ITEM_GROUP_LABEL": "Forrige artikkelgruppe",
      "NEXT_ITEM_GROUP_LABEL": "Neste artikkelgruppe",
      "GO_TO_ITEM_GROUP_LABEL": "Gå til artikkelgruppe %number",
      "PLAY_LABEL": "Start automatisk avspilling",
      "PAUSE_LABEL": "Sett automatisk avspilling på pause",
    },
  },
  "ADVENT_CALENDAR": {
    "TEXT": "Julekalender",
    "LINK": "/advent-calendar",
    // "LINK": "/advent-calendar?testDate=2020-12-1&password=foo",
    "DOOR_TITLE": "Luke %day",
    "VIEW_ALL_PRODUCTS": "Se alle produkter",
    "BACK": "Tilbake til julekalenderen",
    "SAVE_PERCENTAGE": "Spar opptil %percentage%",
    "CATEGORY_URL": "advent-calendar",
    "OPEN_DOOR": "Åpne luke",
    "OPEN_DOOR_ALT": "Åpne luke",
    "CLOSED_DOOR_ALT": "Lukket luke",
    "CALENDAR_CLOSED": "Julekalenderen er stengt",
    "TOTAL_COUNT_EMPTY": "Ingen produkter å vise",
    "TOTAL_COUNT_SINGULAR": "Viser 1 produkt",
    "TOTAL_COUNT_PLURAL": "Viser %totalCount produkter",
    "LANDING": {
      "HEADING": "EUROBONUS SHOP JULEKALENDER",
      "TEXT": "Spennende tilbud hver dag frem til juleaften.",
    },
    "FORM": {
      "SUBSCRIBE_NOW": "Ikke gå glipp av den første luken – meld deg på nå!",
      "EMAIL": "E-mail",
      "SUBMIT": "Meld meg på",
    },
  },
  "ACCOUNT": {
    "MY_ACCOUNT": "Min konto",
    "LOGOUT": "Logg ut",
    "ACCOUNT_INFORMATION": "Kontoinformasjon",
    "OWNER": "Eier",
    "MEMBERSHIP": "Medlemsskap",
    "MEMBERSHIP_LEVEL": "Medlemsnivå",
    "MEMBER_NUMBER": "EuroBonus-nummer",
    "LAST_REGISTERED_POINTS": "Sist registrerte poeng",
    "POINTS_READ_MORE": "Du kan lese mer om poengene dine på",
    "POINTS_READ_MORE_LINK": "https://www.sas.no/",
    "SHIPPING_ADDRESS": "Leveringsadresse",
    "ELAPSED_POINTS": "Utgående poeng",
    "ELAPSING_POINTS_INFO": "Du har %poeng poeng som utløper %date (%dateRelative)",
    "EDIT_INFO_TEXT": "Du endrer kontoinformasjonen din på sas.no",
    "EDIT_INFO": "Endre informasjonen min",
    "WISHLIST": "Ønskeliste",
    "EMAIL": "E-mail",
    "BALANCE": "Poengsaldo",
    "TOTAL_POINTS": "Total",
    "DATE": "Dato",
    "SEE_ALL": "Se alle",
    "BUY_AND_TRANSFER_POINTS": "Kjøp eller gi bort poeng",
    "EDIT": "Endre",
    "EDIT_ADDRESS": "Endre adresse",
    "EDIT_COUNTRY": "Endre land",
    "EDIT_URL": "https://www.sas.no/profile/#/profile?userAction=Settings",
    "READ_MORE": "Les mere",
    "TIER": {
      "B": "Medlem",
      "S": "Sølv",
      "G": "Gull",
      "D": "Diamant",
      "P": "Pandion",
    },
  },
  "COUNTRY": {
    "HEADING": "Velkommen!",
    "DELIVER_TO": "Leveres til",
  },
  "ORDER_HISTORY": {
    "PAGINATION": "Side %current / %total",
  },
  "PURCHASE_POINTS": {
    "CUSTOMER_NOT_ELIGABLE": "Du har ikke tilgang til Buy and Transfer points enda. For å kunne kjøpe, overføre eller ta imot Bonuspoeng må personen ha vært medlem i minst 1 år og ha minst én aktivitet registrert på EuroBonus-kontoen. Du må også ha minst 1000 poeng tilgjengelig på kontoen din. Hvis du mangler poeng for å kunne nå det neste medlemsnivået eller ønsker å sikre ditt eksisterende nivå, kan du kjøpe de Nivåpoengene som du trenger. Dette er nyttig hvis du mangler et begrenset antall poeng.",
    "STEP_NAMES": {
      "find-recipient": "Finn medlem",
      "point-select": "Velg poengsum",
      "payment-split": "Betalingsfordeling",
      "payment": "Oversikt",
    },
    "TITLE": "Kjøp og overfør poeng",
    "DESCRIPTION": "Her kan du kjøpe og overføre Bonuspoeng og Nivåpoeng",
    "BALANCE": "Din poengsaldo er %balance",
    "BASIC_POINTS_EARNED": "Du har så langt tjent %earned Nivåpoeng i løpet av den aktuelle kvalifiseringsperioden.",
    "BUY_FOR_FRIEND": "Kjøp for en venn",
    "TRANSFER_TO_FRIEND": "Overføre for en venn",
    "BUY_FOR_SELF": "Kjøp for deg selv",
    "EDIT": "Endre",
    "SAVE_AND_PROCEED": "Videre",
    "CHOOSE": "Velg",
    "CALCULATING": "…",
    "HOW_MANY_POINTS_PURCHASE": "Hvor mange poeng vil du kjøpe?",
    "HOW_MANY_POINTS_TRANSFER": "Hvor mange Bonuspoeng vil du overføre?",
    "YOU_WILL_RECEIVE": "Du kjøper",
    "SELECT_POINTS_TOOLTIP_TITLE": "Velg poengsum",
    "SELECT_POINTS_TOOLTIP_DESCRIPTION": "Dra slidern for å velge hvor mange poeng du vil kjøpe eller overføre.",
    "PAYMENT_TOOLTIP_TITLE": "Hvordan ønsker du å betale transaksjonsgebyret?",
    "PAYMENT_TOOLTIP_DESCRIPTION": "Dra i slidern for å velge hvordan du vil betale transaksjonsgebyret. Ønsker du å kun betale med poeng drar du den helt til høyre, vil du betale kun med penger drar du den til venstre.",
    "RECIPIENT": "Mottaker",
    "WHO_IS_RECIPIENT": "Hvem vil du overføre poengene til?",
    "CONFIRMATION": "Bekreftelse",
    "CONFIRMATION_SUBTITLE": "Hvordan ønsker du å betale transaksjonsgebyret?",
    "FAQ": {
      "TITLE": "Spørsmål og svar",
      "1": {
        "Q": "Poengene som jeg ønsker å overføre til en annen er i ferd med å gå ut. Hvor lenge blir de gyldige på den andre kontoen?",
        "A": "Når Bonuspoeng overføres, er de gyldige i 5 år fra overføringsdatoen. Men hvis du angrer på kjøpet og bestillingen går tilbake, vil poengene som har utløpt utløpe. Du vil derfor ikke få tilbake poeng som har gått ut siden du overførte dem.",
      },
      "2": {
        "Q": "Hvem kan kjøpe EuroBonus Bonuspoeng?",
        "A": "For å kunne kjøpe, overføre eller ta imot Bonuspoeng må personen ha vært medlem i minst 1 år og ha minst én aktivitet registrert på EuroBonus-kontoen. Du må også ha minst 1000 poeng tilgjengelig på kontoen din.",
      },
      "3": {
        "Q": "Kan jeg få et høyere medlemsnivå hvis jeg kjøper Bonuspoeng eller får Bonuspoeng overført til kontoen min?",
        "A": "Nei, Bonuspoeng kvalifiserer ikke til høyere medlemsnivå. For å nå et høyere medlemsnivå trenger du Nivåpoeng. Det er kun mulig å kjøpe Nivåpoeng hvis du først har tjent opp størsteparten av Nivåpoengene ved å fly.",
      },
      "4": {
        "Q": "Hvor mange poeng kan et medlem få fra et annet medlem per år?",
        "A": "Uansett om det er kjøpte Bonuspoeng eller overførte poeng, så kan mottakeren få opptil 100 000 EuroBonus Bonuspoeng per år.",
      },
      "VIEW_MORE": "Se flere spørsmål og svar",
    },
    "FIND_RECIPIENT": {
      "EB": "EuroBonus-nummer",
      "FIND_TRAVELER": "Finn medlem",
      "LAST_NAME": "Etternavn",
      "SUCCESS": "Medlemmet kan motta ytterligere %points poengi år.",
    },
    "PAYMENT_BOX": {
      "TITLE": "Hvordan ønsker du å betale transaksjonsgebyret?",
      "PAY_WITH_POINTS": "Betal med poeng (+%poeng)",
      "PAY_WITH_CASH": "Direktbetaling (+%cash) SEK",
      "SUMMARY": "Sum",
      "GIFTED_POINTS": "Antall poeng",
      "TRANSACTION_FEE": "Transaksjonsgebyr",
      "TO_PAY": "Å betale",
      "TRANSFER_POINTS": "Overfør poeng",
    },
    "SUCCESS": {
      "TITLE": "Bestilling registrert",
      "ORDER_NUMBER": "Ordernummer",
      "ORDER_OVERVIEW": "Orderoversikt",
      "CONFIRMATION": "Bekreftelse",
      "CONFIRMATION_INFO": "Du har nå gjennomført et kjøp av EuroBonus-point til %member. Her følger informasjon om kjøpet. En kvittering er blitt sendt til din e-post. Har du spørsmål er du velkommen å kontakte kundeservice.",
      "INFORMATION": "Information",
      "INFORMATION_INFO": "EuroBonus-poengene blir overført direkte, men det kan ta opptil 24 h før de blir synlige på kontoen. Kontakt kundeservice med spørsmål.",
      "CONTACT_US": "Ta kontakt med kundeservice",
      "CONTACT_US_INFO": "Hvis du har spørsmål angående sortimentet eller bestillingen din, kan du kontakte oss!",
      "CUSTOMER_SERVICE": "Kundeservice",
      "TRAVELER": "Medlem",
      "EUROBONUS_NUMBER": "EuroBonus-nummer",
      "LAST_NAME": "Etternavn",
      "ORDER_CONTENTS": "Orderinnhold",
      "PRODUCT": "Produkt",
      "PAYMENT": "Gebyr",
      "CASH": "Kortbetaling",
      "POINTS": "Poeng",
    },
    "STEPS": {
      "TRAVELER": "Mottaker",
      "PURCHASE_POINTS": "Antall",
      "CONFIRMATION": "Bekreftelse",
      "SUMMARY": "Summering",
      "PAYMENT": "Betaling",
    },
    "TIERS": {
      "EARNED_CURRENT": "Du har opptjent %points i din nåværende kvalifiseringsperiode.",
      "EARNED_PREVIOUS": "Du tjente totalt %points i løpet av forrige kvalifiseringsperiode.",
      "EXTEND": "Kjøp ytterligere %points for å beholde",
      "UPGRADE": "Kjøp ytterligere %points for å oppgradere til",
      "LEVEL": "medlemskap.",
    },
    "BASIC_POINTS": {
      "HEADER": "Kjøp Nivåpoeng",
      "INFO": "Kontoen din oppfyller ikke kravene for å kjøpe Nivåpoeng.",
      "LINK": "For mer informasjon les her.",
    },
  },
  "SORT": {
    "OFFCANVAS": {
      "TITLE": "Sortere",
      "SHOW_RESULT": "Se resultat",
      "CLOSE_MENU": "Lukk sorteringsmenyen",
    },
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Alle filtre",
      "FILTER_BY_POINTS": "Filtrer etter poeng",
      "FILTER_BY_PRICE": "Filtrer etter pris",
      "PRICE_RANGE_MIN": "%min poeng",
      "PRICE_RANGE_MAX": "%max poeng",
      "SORT": "Sortere",
      "SORT_DEFAULT": "Utvalgte",
      "SORT_NAME_DOWN": "Produktnavn: A-Ø",
      "SORT_NAME_UP": "Produktnavn: Ø-A",
      "SORT_PRICE_DOWN": "Dyrest",
      "SORT_PRICE_UP": "Billigst",
      "SORT_POSITION_DOWN": "Mest populær",
      "SORT_POPULAR_DOWN": "Mest populær",
      "SORT_VALUE_DOWN": "Verdi: Lav",
      "SORT_VALUE_UP": "Verdi: Høy",
      "SORT_RELEASE_DATE_DOWN": "Utgivelsesdato: Siste",
      "SORT_RELEASE_DATE_UP": "Utgivelsesdato: Eldste",
      "SORT_LATEST_DOWN": "Siste",
      "SORT_MANUFACTURER_DOWN": "Varemerke: Ø-A",
      "SORT_MANUFACTURER_UP": "Varemerke: A-Ø",
      "SORT_CREATED_AT_DOWN": "Sist lagt til: Siste",
      "SORT_CREATED_AT_UP": "Sist lagt til: Eldst",
      "SORT_RELEVANCE_DOWN": "Mest relevant",
      "SORT_RELEVANCE_UP": "Minst relevant",
      "RANGESLIDER": "Skyveknapp",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total produkter",
      "SHOW_RESULT": "Se resultat",
      "CLOSE_MENU": "Lukk filtermenyen",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Fjern filtrene",
      "NO_ACTIVE_FILTERS": "Du har ingen aktive filtre",
      "PRICE_RANGE": "Pris (%range)",
      "TOTAL_COUNT": "Viser %count produkter",
      "REMOVE": "Fjern filter",
    },
    "FILTERMENU": {
      "FILTER_BY_PRICE": "Filtrer etter poeng",
      "FILTER_BY_POINTS": "Filtrer etter pris",
      "RESET_PRICE": "Fjern",
      "PRICE_FROM": "Fra",
      "PRICE_TO": "Til",
      "BALANCE_FILTER": "Filtrer på poengsaldo (%value poeng)",
      "WITHIN_BALANCE": "Produkter innenfor poengbalanse",
    },
  },
  "WISHLIST": {
    "TITLE": "Ønskeliste",
    "ADD_TO_WISHLIST": "Legg til i ønskeliste",
    "REMOVE_FROM_WISHLIST": "Fjern fra ønskelisten",
    "EMPTY": "Du har ingen produkter i ønskelisten din.",
    "EXPLORE_ASSORTMENT": "Utforsk sortimentet",
  },
  "ADDRESS": {
    "FIRSTNAME": "Fornavn",
    "LASTNAME": "Etternavn",
    "STREET_1": "Adresse 1",
    "STREET_2": "Adresse 2 (frivillig)",
    "POSTCODE": "Postnummer",
    "CITY": "By",
    "COUNTRY": "Land",
    "EMAIL": "Epost",
    "TELEPHONE": "Telefon",
    "EDIT": "Endre",
    "NOT_YOUR_COUNTRY": "Ikke ditt land?",
  },
  "OR": "eller",
  "CART": {
    "EMPTY": "Handlekurven er tom",
    "CANT_AFFORD_TITLE": "For lav poengsaldo",
    "CANT_AFFORD_INFO": "Du har ikke nok poeng for denne bestilling.",
    "OF": "av",
    "NAV_BUTTON_OPEN": "Åpne handlekurv – %count vare(r)",
    "NAV_BUTTON_CLOSE": "Lukk handlekurv – %count vare(r)",
    "NAV_BUTTON_CART": "Gå til handlekurv – %count vare(r)",
    "CTA": "Gå til kassen",
    "ALT": "Endre i handlekurven",
    "EDIT": "Endre i handlekurven",
    "TO_PAY": "Å betale",
    "INCREMENT": "Øk antallet",
    "DECREMENT": "Reduser antallet",
    "QUANTITY": "Antall",
    "CONTINUE_SHOPPING": "fortsett å handle",
    "SHIPPING": "Frakt",
    "SUBTOTAL": "Beløp",
    "GRANDTOTAL": "Total",
    "YOUR_BALANCE": "Poengsaldo",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå til kassen",
    "TO_CHECKOUT_CANT_AFFORD": "Du har ikke nok poeng til å fullføre dette kjøpet.",
    "REMOVE_PRODUCT": "Fjern produktet",
    "REMOVE_APPROVE": "Ja, fjern",
    "CONFIRM_TEXT": "Vil du virkelig fjerne '%itemName' fra handlekurven?",
    "YOULL_EARN": "Du vil optjene %points",
    "MINIMIZE_SUMMARY": "Minimer oversikt",
    "VIEW_DETAILS": "Se detaljer",
    "PAY_ONLY_WITH_PTS": "Kun poeng",
    "ACCRUAL_TOOLTIP_TITLE": "Opptjen poeng",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "Når du kjøper visse produkter opptjener du EuroBonus-poeng. Poengene blir satt inn på kontoen din 1 måned etter at kjøpet er fullført.",
    "CLOSE": "Lukk handlekurven",
    "CLOSE_SUMMARY": "Lukk oppsummeringen",
    "OPEN_SUMMARY": "Åpne oppsummeringen",
    "SUBMIT": "Lagre antall",
  },
  "DIALOGUE": {
    "CANCEL": "Kansellere",
    "CLOSE": "Lukk dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Lukk banner",
  },
  "CHECKOUT": {
    "NEED_HELP": "Trenger du hjelp? Vi er her for deg!",
    "CONTACT_CUSTOMER_SERVICE": "Ta kontakt med kundeservice",
    "TO_PAYMENT": "Gå til betaling",
    "CHOOSE_PAYMENT_METHOD": "Videre til betaling",
    "POINTS_TITLE": "Betal med poeng",
    "POINTS_BALANCE": "Du har %points, hvor mange vil du bruke?",
    "AMOUNT_TO_PAY": "Å betale",
    "TOOLTIP_TITLE": "Betal med poeng",
    "TOOLTIP_DESCRIPTION": "I SAS EuroBonus Shop kan du handle med poeng, penger eller en kombinasjon av begge. Ved å dra i reglasjen velger du enkelt hvor mange poeng du vil bruke til ditt kjøp. Ønsker du å bruke alle dine poeng drar du reglasjen helt til høyre og vil du betale ditt kjøp med kun penger drar du isteden reglasjen helt til venstre.",
    "POINTS": "Poeng",
    "CASH": "Cash",
    "PAY_WITH_CARD": "Betal med kort",
    "CARD_PAYMENT": "Betal med kort",
    "EDIT": "Endre",
    "PAYMENT_AND_DELIVERY": "Betaling & leveranse",
    "DISTRIBUTION_POINTS": "EuroBonus-poeng",
    "DISTRIBUTION_CASH": "Kompletterne betaling med kort",
    "SENT_TO": "Sendes til",
    "CONFIRM_ORDER": "Fullfør bestillingen",
    "CONTINUE_SHOPPING": "Fortsett å handle",
    "PAYMENT_TITLE": "Hvordan vil du betale?",
    "I_ACCEPT_THE": "Jeg accepterer",
    "TERMS": "kjøpsvilkårene",
    "ACCORDION_HEADER_CART": "Handlekurv",

    "ADDRESS": {
      "ADDRESS": "Adresse",
      "SHIPPING": "Leveringsadresse",
      "BILLING": "Kvitteringsadresse",
      "SHIP_TO_SAME_ADDRESS": "Samme adresse på kvitteringen",
      "EMPTY_ADDRESS": "Adressen er ikke fullstendig, vennligst oppdater",
    },
    "STEPS": {
      "CART": {
        "SHORT": "Handlekurv",
        "LONG": "Handlekurv",
      },
      "SHIPPING": {
        "SHORT": "Levering",
        "LONG": "Kontrollere adresse",
      },
      "PAYMENT": {
        "SHORT": "Fordele betaling",
        "LONG": "Fordele din betaling",
      },
      "OVERVIEW": {
        "SHORT": "Betale",
        "LONG": "Oversikt",
      },
    },
  },
  "PAYMENT": {
    "USE_CARD": "Betal med kort",
    "USE_SAVED_CARD": "Betal med lagret kort",
  },
  "PAYMENT_METHODS": {
    "APPLE_PAY": "pay",
  },
  "CUSTOMER_SERVICE": {
    "TEXT": "Kundeservice",
    "LINK": "/customer-service",
  },
  "SUCCESS": {
    "TITLE": "Bestilling registrert",
    "SUB_TITLE": "Ordrenummer %number",
    "BACK": "Tilbake til butikken",
    "VALID_UNTIL": "Gyldig t.o.m. %date",
    "WHAT_NOW": "Hva sker nå?",
    "ORDER_OVERVIEW": "Ordreoversikt",
    "NOT_FOUND_TITLE": "Ingen ordre funnet.",
    "NOT_FOUND_SUBTITLE": "Ta kontakt med kundeservice hvis dette er feil.",
    "CONTACT": {
      "TITLE": "Lurer du på noe?",
      "CREATE_TICKET": "Oprett sak",
      "INFO": "Hvis du har spørsmål angående sortimentet eller bestillingen din, kan du kontakte oss!",
      "OR": "eller",
      "REGRET_PURCHASE": "Angre på kjøpet mitt",
      "CALL_US": "Ring oss",
      "CALL_US_HOURS": "Arbeidsdager mellom: 09.00-12.00",
      "CALL_US_PHONENUMBER": "+47 21 93 97 20",
    },
    "STEPS": {
      "NORMAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "En ordrebekreftelse vil bli sendt til %email innen kort.",
        },
        "2": {
          "HEADING": "Behandling",
          "TEXT": "Bestillingen blir sendt når alle produktene er tilgjengelige for levering. Dette skjer vanligvis nestkommende dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når varene er pakket og sendt, vil du bli varslet via e-post. I leveringsbekreftelsen finner du en sporingslenke så du kan følge pakkenes vei. Levering tar normalt 3-7 dager.",
        },
        "4": {
          "HEADING": "Leveranse",
          "TEXT": "Pakken blir levert til nærmeste utleveringssted, og du vil bli varslet via SMS til mobilnummeret du oppga i bestillingen. Pakken vil bli oppbevart på utleveringsstedet i 14 dager.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "En ordrebekreftelse og dine digitale biljetter/verdikoder sendes til %email innen kort. Hvis du ikke har mottatt noen e-post, kan du dobbeltsjekke spamfilteret før du kontakter kundeservice",
        },
        "2": {
          "HEADING": "Behandling",
          "TEXT": "Din bestilling blir sendt når alle produktene er tilgjengelige for leveranse. Vanligvis er dette nestkommende dag. Digitale produkter sendes direkte til den oppgitte e-posten.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "Når varene er pakket og sendt, vil du bli varslet via e-post. I leveringsbekreftelsen finner du en sporingslenke så du kan følge pakkenes vei. Levering tar normalt 3-7 dager.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Pakken blir levert til nærmeste utleveringssted, og du vil bli varslet via SMS til mobilnummeret du oppga i bestillingen. Pakken vil bli oppbevart på utleveringsstedet i 14 dager. Din digitale bestilling sendes direkte til din oppgitte e-post.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekreftelse",
          "TEXT": "En ordrebekreftelse sendes til %email innen kort tid.",
        },
        "2": {
          "HEADING": "Digital leveranse",
          "TEXT": "Din bestilling vil bli sendt direkte til %email. Hvis du ikke har mottatt en e-post, vennligst dobbeltsjekk spamfilteret og søppelposten før du kontakter kundeservice.",
        },
      },
    },
  },
  "SERIAL_CODE": {
    "FETCH_STATUS": {
      "LOADING": "Vent mens vi lader din verdikode",
      "ERROR": "En feil oppsto. Din kode er sent til din e-post.",
    },
  },
  "OLD_BROWSER": {
    "INFO": "Hei! Du bruker en utdatert nettleser. Vennligst <a href=\"http://outdatedbrowser.com\" rel=\"noopener\" target=\"blank\">uoppdater nettleseren</a>for å bruke saseurobonusshop.com",
  },
  "CATEGORY": {
    "PRODUCTS_IN_CATEGORY_TITLE_SINGULAR": "Viser 1 produkt i",
    "PRODUCTS_IN_CATEGORY_TITLE_PLURAL": "Viser %itemsCount produkter i",
    "PRODUCTS_IN_CATEGORY_TITLE_EMPTY": "Viser produkter i",
    "SEE_ALL_IN_MAIN_CATEGORY": "Se alle i %mainCategory",
  },
  "PRODUCTLIST": {
    "EMPTY": "Det er ingen produkter å vise akkurat nå",
  },
  "POPULAR": {
    "POPULAR_PRODUCTS": "Populære produkter",
  },
  "404": {
    "TITLE": "Beklager, siden kan ikke finnes.",
    "HEADING": "— 404 —",
    "SUBHEADING": "Beklager, siden kan ikke finnes.",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfeil",
    "HEADING": "Serverfeil: 500",
    "SUBHEADING": "Vennligst kom igjen innen kort",
    "TEXT": "",
  },
  "SLIDER": {
    "SLIDE": "Lysbilde %number",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Søk: ",
    "PLACEHOLDER": "Søk i EuroBonus-sortimentet",
    "RESULTS": "Søkeresultater for \"%query\"",
    "TYPE": {
      "CATEGORY": "Kategori",
      "PRODUCT": "Produkt",
      "BRAND": "Varemerke",
    },
    "OPEN": "Åpne søk",
    "CLOSE": "Lukk søkemenyen",
    "SEARCH_RESULT": "Fant 1 produkt som matchet",
    "PRODUCTS_IN_SEARCH_RESULT": "Fant %itemsCount produkter som matchet",
    "PRODUCT_IN_SEARCH_RESULT": "Fant ett produkt som matchet",
    "EMPTY": "Ingen produkter å vise akkurat nå",
  },
  "ICONS": {
    "CHEVRON": "Pil",
    "CROSS": "Kryss",
    "SEARCH": "Forstørrelsesglass",
    "HAMBURGER": "Tre horisontale streker (hamburgermeny)",
    "HEADPHONES": "Hodesett med mikrofon",
    "CART": "Handlekurv",
    "FILTER": "Tre linjer med hver sin sirkel",
    "SORT": "Tre horisontale streker (sorteringsikon)",
    "CHECK": "Hake",
    "CHAT": "Snakkeboble",
    "PHONE": "Telefon",
    "INFO": "Sirkel med en i inni",
    "PLUS": "Pluss-tegn",
    "MINUS": "Minus-tegn",
    "SWEDEN_FLAG": "Svensk flagg",
    "NORWAY_FLAG": "Norsk flagg",
    "DENMARK_FLAG": "Dansk flagg",
    "OTHER_FLAG": "Jordklode",
    "HEART_EMPTY": "Tomt hjerte",
    "HEART_FILLED": "Fylt hjerte",
    "AMEX": "Logo for Amex",
    "MASTERCARD": "Logo for Mastercard",
    "VISA": "Logo for Visa",
    "GOOGLE_PAY": "Logo for Google Pay",
    "MS_PAY": "Logo for Microsoft Wallet",
    "APPLE_PAY": "Logo for Apple Pay",
    "LINK": "Firkant med pil inni (lenkeikon)",
    "HEADSUP": "Utfylt sirkel med utropstegn inni",
  },
  "HEADER": {
    "SHOPNAME": "EuroBonus Shop",
    "NAVIGATION": "Navigasjon",
    "MAIN_NAVIGATION": "Hovedmeny",
    "SEARCH": "Søk",
    "CATEGORIES": "Kategorier",
    "BRANDS": "Varemerker",
    "CART": "Kassen",
    "LOGOUT": "Logg ut",
    "LOGIN": "Logg in",
    "DELIVER_TO": "Levering til",
    "GO_TO_SAS": "Gå til sas.no",
    "MY_ACCOUNT": "Min konto",
    "GIFTCARDS": "Gavekort",
    "CLOSE": "Lukk",
    "OPEN_MENU": "Åpne menyen",
    "CLOSE_MENU": "Lukk menyen",
    "GO_BACK": "Gå tilbake",
    "CONTACT": "Kontakt oss",
  },
  "DRAWER": {
    "OPEN_SUBMENU": "Åpne undermeny",
    "CLOSE_SUBMENU": "Lukk undermeny",
  },
  "FOOTER": {
    "LINKS": {
      "NAVIGATION": "Bunntekstmeny",
      "TERMS": {
        "TEXT": "Vilkår",
        "LINK": "/terms",
      },
      "PRIVACY_POLICY": {
        "TEXT": "Personvernpolicy",
        "LINK": "/privacy-policy",
      },
      "ACCESSIBILITY": {
        "TEXT": "Tilgjengelighet",
        "LINK": "/accessibility",
      },
    },
    "COPYRIGHT": "© %year Scandinavian Airlines System-Denmark-Norway-Sweden, org.nr 902001-7720, 195 87 Stockholm",
    "LEGAL": "Butikk SAS EuroBonus drives av Crossroads Loyalty Solutions AS (Postboks 331 Skøyen NO-0213 Oslo).<br />Copyright © %year Crossroads Loyalty Solutions AS. Alle rettigheter forbeholdt.",
    "NEED_HELP": {
      "COOKIES": "Administrer cookies",
    },
  },
  "BREADCRUMBS": {
    "HOME": "Hjem",
    "HOME_URL": "/",
    "SEARCH": "Søkresultater for \"%query\"",
    "ADVENT_CALENDAR": "Julekalender",
  },
  "PRODUCT": {
    "ADD_TO_CART": "Legg i handlekurv",
    "OUT_OF_STOCK": "Utsolgt",
    "RELATED_PRODUCTS": "Relaterte produkter",
    "CROSS_SELL_PRODUCTS": "Andre produkter du kanskje synes er interessante",
    "OPTION_DROPDOWN_PLACEHOLDER": "Velg ett valg",
    "LOGIN_TO_PURCHASE": "Logg inn for å handle",
    "CHANGE_IMAGE": "Endre bilde",
    "GO_TO_MANUFACTURER": "Se alle produkter fra %brand",
    "ABOUT_BRAND": "Om %brand",
    "COLOR": "Farge",
    "CHOOSE_A_COLOR": "Velg en farge",
    "POINTS_ONLY": "Kun poeng",
    "EARN": "Opptjen %points",
    "EARN_UP_TO": "Opptjen opptil %points",
    "PAY_AT_LEAST_PTS": "Du må betale med minst %points poeng for å kjøpe dette produkt. Resten betales med kort.",
    "PAY_ONLY_WITH_PTS": "Dette produkt kan kun betales med poeng.",
    "DESCRIPTION": "Produktbeskrivelse",
    "EARNINGS": "Opptjening fra dette kjøp",
    "SHIPPING_TERMS": "Leveransevilkår",
    "ACCRUAL_TOOLTIP_TITLE": "Opptjen poeng",
    "ACCRUAL_TOOLTIP_DESCRIPTION": "Når du kjøper dette produkt opptjener du EuroBonus-poeng. Poengene blir satt inn på kontoen din 1 måned etter at kjøpet er fullført.",
    "REDEMPTION_DISABLED": "Du kan ikke kjøpe noe med din konto akkurat nå, vennligst kontakt SAS customer service.",
    "EXPERIENCE_URL_BUTTON": "Til produktet",
    "EXTERNAL_EXPERIENCE": "SAS Experience",
    "EXTERNAL_EXPERIENCE_URL": "/experiences-by-eurobonus",
  },
  "MISSING_ADDRESS_TEXT": "Du må skrive inn adressen din og kontaktopplysningene dine på <a target='_blank' href='https://www.sas.no/profile/settings/'>sas.no</a>",
  "MISSING_ADDRESS_TEXT_LONG": "Du må skrive inn adressen din og kontaktopplysningene dine på <a target='_blank' href='https://www.sas.no/profile/settings/'>sas.no</a> for å kunne overføre Bonuspoeng, kjøpe Bonuspoeng eller Nivåpoeng.",
  "STRIPE": {
    "PROCESSING": "Lader…",
    "CARD_NUMBER": "Kortnummer",
    "MM/YY": "MM/ÅÅ",
    "CVC": "CVC",
  },
  "NEWSLETTER": {
    "SUCCESS_TITLE": "Bekreft din e-postadresse",
    "SUCCESS_BODY": "For å fullføre registreringen, vennligst sjekk e-posten din og bekreft e-postadressen din ved å følge lenken i e-postmeldingen du har mottatt fra oss.",
    "ERROR_TITLE": "Noe har gått galt",
    "ERROR_BODY": "Vennligst prøv å registrere deg på nytt.",
    "FINISHED_TITLE": "Takk for din påmelding",
  },
  "OTP": {
    "TITLE": "Verifiser din EuroBonus-konto",
    "INFO": "En verifiseringskode har blitt sendt til telefonnummeret som er registrert på din Eurobonus profil.",
    "FIELD_LABEL": "Kode",
    "SUBMIT": "Verifiser eierskap",
    "REQUEST_NEW_CODE_TITLE": "Fikk du ikke koden?",
    "REQUEST_NEW_CODE": "Send en ny kode",
    "CUSTOMER_SERVICE": "Ta kontakt med kundeservice",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatorisk felt",
    "EMAIL": "Skriv inn riktig e-postadresse",
    "errorInvalidEmail": "Skriv inn riktig e-postadresse",
    "errorEmailExists": "E-postadressen du oppga er allerede brukt",
    "PHONE": "Skriv inn riktig mobilnummer",
    "NUMERIC": "Feltet kan bare inneholde tall",
    "LENGTH_LT": "Feltet inneholder for mange tegn",
    "POSTCODE": "Skriv inn riktig postnummer",
    "NO_SHIPPING_GB": "Ikke tilgjengelig på grunn av Brexit",
  },
  "STATUS_CODE": {
    /* Client */
    "UNKNOWN": "En ukjent feil har oppstått. Last inn siden på nytt og prøv igjen.",
    "NETWORK_ERROR": "Sideladingen ble avbrutt. Kontroller at du har en aktiv Internett-tilkobling, eller prøv igjen om et øyeblikk.",
    "PLACE_ORDER_CATCH": "En feil oppstod. Prøv igjen senere.",
    "AQUIRER_DECLINE": "Betalingen har blitt avvist. Vennligst bekreft kort-/kontoopplysningene dine.",

    "errorUnknownProduct": "Ukjent produkt, prøv igjen.",

    "errorProductQuantityNotAvailable": "Beklager, det spesifiserte antallet er for tiden ikke på lager.",
    "errorProductNotInStock": "Dessverre er produktet du prøvde å legge i handlekurven for tiden ikke på lager.",
    "errorProductMaxQuantity": "Beklager, det spesifiserte antallet er for tiden ikke på lager.",
    "errorProductNotChosenVariant": "Velg %attributeLabel for å kunne legge produktet til i handlekurven din.",
    "termsNotAccepted": "Du må godkjenne kjøpsbetingelsene for å fullføre kjøpet.",

    "errorNotLoggedIn": "Du er ikke logget inn. Vennligst logg inn igjen.",
    "errorInvalidState": "En feil oppstod. Vennligst prøv igjen.",
    "errorInvalidLogin": "Feil inloggningsdetaljer",
    "errorMissingCustomer": "Kunden du prøver å logge inn på, eksisterer ikke",
    "errorInsufficientSasPointsForPurchase": "Kontosaldoen er for lav",
    "errorBlacklistedEmail": "E-postadressen du oppga er allerede brukt. Oppgi en annen.",
    "errorEmailExists": "E-postadressen du oppga er allerede brukt. Oppgi en annen.",
    "errorInvalidEmailOrPassword": "Feil inloggningsdetaljer",

    "errorBillingAddressValidationFailed": "Ugyldig adresse. Prøv igjen",
    "errorShippingAddressValidationFailed": "Ugyldig adresse. Prøv igjen",
    "errorInvalidEmailAddress": "Ugyldige kontaktopplysninger",
    "errorInvalidEmail": "Ugyldig E-postadresse",

    "errorNoItems": "Uventet feil, prøv igjen",
    "errorNoShippingMethod": "Uventet feil, prøv igjen",
    "errorProductsNotAvailable": "Uventet feil, prøv igjen",

    "errorPaymentNotAvailable": "Betalingsfeil",
    "errorInvalidPaymentMethod": "Betalingsfeil",
    "errorNoPaymentMethod": "Betalingsfeil",

    "errorFraudOrder": "Kjøpet er ikke tillatt. Kontakt support for mer informasjon.",
    "errorFraudProduct": "Grensen er nådd for ett eller flere produkter i handlekurven. Kontakt support for mer informasjon.",
    "errorFraudBlacklist": "Kjøpet er ikke tillatt. Kontakt support for mer informasjon.",

    "Your card number is incomplete": "Vennligst oppgi kortinformasjonen din.",

    "YOUR_CARD_HAS_INSUFFICIENT_FUNDS": "Du har ikke dekning på kortet.",
    "YOUR_CARDS_SECURITY_CODE_IS_INCORRECT": "CVC-koden for kortet er ikke korrekt.",
    "YOUR_CARD_WAS_DECLINED": "Kortet ble nektet",
    "YOUR_CARD_HAS_EXPIRED": "Kortet er utløpt",
    "AN_ERROR_OCCURRED_WHILE_PROCESSING_YOUR_CARD_TRY_AGAIN_IN_A_LITTLE_BIT": "Det oppstod en feil. Prøv igjen om noen øyeblikk.",
    "WE_ARE_UNABLE_TO_AUTHENTICATE_YOUR_PAYMENT_METHOD_PLEASE_CHOOSE_A_DIFFERENT_PAYMENT_METHOD_AND_TRY_AGAIN": "Vi kunne ikke godkjenne betalingsmåten. Vær så snill, prøv på nytt.",
    "INTERNAL_SERVER_ERROR": "Intern server feil.",

    "CODE_COPIED": "Verdikoden er kopiert",
    "CODE_NOT_COPIED": "Verdikoden kunne ikke kopieres",
    "errorPointRedemptionNotAllowed": "Kjøp med poeng er ikke mulig på din konto akkurat nå.",
    "ITEM_REMOVED_FROM_CART": "%name ble fjernet fra handlekurven din siden den ikke lenger er på lager.",
    "WISHLIST_VARIANT": "Velg et alternativ først",
    "NO_SHIPPING_GB": "På grunn av Brexit og de nye reglene, kan vi for øyeblikket ikke levere til Storbritannia. Vi jobber på heltid med dette og håper på en løsning snart.",
    "errorGeneralError": "Desverre kunne vi ikke sende en verifiseringskode til deg - Vi ber deg prøve igjen senere eller kontakte SAS kundeservice.",

    // OTP
    "invalid_sso_token_or_otp": "Sessionen din har utløpt. Vennligst logg inn igjen.",
    "invalid_sso_ticket": "Sessionen din har utløpt. Vennligst logg inn igjen.",
    "NEW_OTP_SMS_SENT": "Ny kode sendes",
    "ERROR_VALIDATION": "Validation error. Check that the data is correct and try again.",
    "ERROR_OTP_EMAIL": "Issues with the mail service. Try again later. If problem remains, contact SAS support.",
    "ERROR_OTP_SMS": "Issues with the SMS service. Try again later. If problem remains, contact SAS support.",
    "ERROR_PROFILEDATA_LOOKUP": "Could not look up profile data. Try again later.",
    "SERVICE_UNAVAILABLE": "The service is currently unavailable. Try again later.",
    "ERROR_REGION_PHONE": "Cannot reach regions phone number. Try again later.",
    "ERROR_TIMEOUT": "Timeout. Wait and try again later.",
    "ERROR_MAX_ATTEMPTS_REACHED": "For mange anrop. Vennligst vent noen minutter og prøv igjen.",

    "ADVENT_CALENDAR": {
      "notModified": "E-postadressen er allrede registrert",
      "invalidEmail": "Ugyldig e-postadresse",
      "success": "Du er nå registrert",
    },

    "TRANSFER_POINTS": {
      "errorNotFound": "Vi kunne ikke finne en bruker med det EuroBonus-nummeret.",
      "errorTooManySuccess": "For mange søkeforsøk. Prøv igjen senere.",
      "noSuccess": "En ukjent feil har oppstått. Last inn siden på nytt og prøv igjen.",
      "errorCannotTransferTo": "Det er ikke mulig å overføre poeng til denne mottakeren.",
      "errorPointRedemptionNotAllowed": "Du er for øyeblikket ikke inne i en kvalifiserings- eller utsettelsesperiode hvor poengene vil telle mot bonusnivået ditt.",
      "errorCannotBuyForSelf": "Din konto oppfyller ikke kravene for å kjøpe poeng til deg selv.",
      "errorCannotBuyForOther": "Din konto oppfyller ikke kravene for å kjøpe eller overføre poeng til en annen konto.",
    },
  },
};
